var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"chart"}},[_c('apexchart',{attrs:{"type":_vm.type,"options":_vm.chartOptions,"series":_vm.series,"labels":_vm.labels,"width":_vm.width}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }